import { render, staticRenderFns } from "./payment-gate.vue?vue&type=template&id=891e23dc&scoped=true"
import script from "./payment-gate.vue?vue&type=script&lang=js"
export * from "./payment-gate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891e23dc",
  null
  
)

export default component.exports